<template>
    <div class="topbar p-3 bg-white">
        <div class="header-left">
            <div class="topnav">
                <ul class="nav nav-icons">
                    <a href="javascript:void(0);">
                        <span>
                            <h4>Zorbis</h4>
                            <!-- <img :src="companyLogo" style="height: 50px;width: 100%;" alt="Logo"> -->
                        </span>
                    </a>
                </ul>
            </div>
        </div>

        <div class="header-center">
            <h2 class="text-dark"></h2>
        </div>
        <div class="header-right">
            <h2 class="text-dark" style="margin-top: -53px;">Welcome {{ joinerName }}</h2>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from "vue";

//================ Props====================
const props = defineProps({
    joinerName:String
})

const companyLogo = ref("https://stagemedia.ruvena.com/resources/uploads/companyLogo/ruven-logo.png");
const joinerName = ref(props.joinerName)

console.log("joinerName",joinerName)


onMounted(() => {
    
})
</script>

<style scoped>
.ng-select .ng-clear-wrapper {
    display: none;
}

.main-content {
    margin: 0px !important;
}

.topbar {
    position: relative;
    height: auto !important;
    left: 0px;
    background-color: #2f4050;
    flex-wrap: wrap;
}

@media only screen and (max-width: 1028px) {
    .topbar .header-left .nav-icons {
        display: block;
    }
}

@media only screen and (max-width: 768px) {

    .topbar .header-left,
    .topbar .header-center,
    .topbar .header-right {
        width: 100%;
        text-align: center;
    }
}</style>